import { Navbar, Nav, Button } from "react-bootstrap";
import Logo from "./assets/images/png/logo.png";
import Logo2 from "./assets/images/png/logo2.png";
import Mail from "./assets/images/png/mail.png";

export const Navi = () =>{
    const navFontWhite = "rgba(255, 255, 255, 0.8)";

    return(
        <>
            <Navbar
            collapseOnSelect
            className="fixed-top container-fluid py-1 px-4 m-0"
            expand="md"
            style={{
                backgroundColor: "rgba(108, 122, 137, 0.8)",
                boxShadow: "0 3px 6px rgba(0, 0, 0, 0.05)"
            }}
            >
                <Navbar.Brand className="me-auto" href="/">
                    <div className="d-none d-md-block fs-3">
                        <img src={Logo} alt="logo" width="40" />
                        <span
                            className={"ms-3"}
                            style={{
                            letterSpacing: "7px",
                            color: navFontWhite
                            }}
                        >
                            fueri
                        </span>
                    </div>
                    <img
                    src={Logo2}
                    alt="logo"
                    className="d-block d-md-none mt-1"
                    width="50"
                    />
                </Navbar.Brand>
                <div className="d-block d-md-none me-4">
                    <a href='/#Form'>
                        <img
                        src={Mail}
                        alt="mail"
                        width="40"
                        />
                    </a>
                </div>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse
                    id="responsive-navbar-nav"
                    className="justify-content-end"
                >
                    <Nav
                    className="text-center align-baseline"
                    style={{
                        fontSize: "1.1rem"
                    }}
                    >
                        <Nav.Link
                        href="/#top"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            トップ
                        </Nav.Link>
                        <Nav.Link
                        href="/#service"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            サービス
                        </Nav.Link>
                        <Nav.Link
                        href="/#workFlow"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            制作の流れ
                        </Nav.Link>
                        <Nav.Link
                        href="/#price"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            料金紹介
                        </Nav.Link>
                        <Nav.Link
                        href="/#fAQ"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            よくある質問
                        </Nav.Link>
                        <Nav.Link
                        href="/#profile"
                        className={"me-md-4"}
                        style={{
                        color: navFontWhite,
                        textDecoration : "none"
                        }}
                        >
                            プロフィール
                        </Nav.Link>
                        <Nav.Link
                        href="/#form"
                        className={"d-block d-md-none me-md-4"}
                        style={{
                        color: navFontWhite
                        }}
                        >
                            お問い合わせ
                        </Nav.Link>
                    </Nav>
                    <div className="d-none d-md-block ms-2">
                        <Button variant="success" href="/#form">
                            お問い合わせ
                        </Button>
                    </div>
                </Navbar.Collapse>
            </Navbar>
        </>
    )
};